import React from "react";
import { useEnquiryModel } from "../enquiryModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useEnquiryModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "配件编码",
            fieldName: "code"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "配件名称",
            fieldName: "name"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "询价单号",
            fieldName: "enquiryCode"
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["审批日期开始", "审批日期结束"],
            rangePickerFieldName: ["approvalStartTime", "approvalEndTime"],
            format: "YYYY-MM-DD",
            span: 4,
            xxl: 4,
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["截止日期开始", "截止日期结束"],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 4,
            xxl: 4,
        },
    ]


    return (
        <YhPageHeader
            title="询价统计"

            size="small"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}